import { Button, HFlow } from 'bold-ui'
import { useAcessoLotacaoOrEstagio } from 'components/auth/useAcessoLotacao'
import { useUltimoArquivoTemporarioProntoEmProcessamentoQuery } from 'graphql/hooks.generated'
import { ArquivoTemporarioIdentificadorEnum } from 'graphql/types.generated'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { usePubSub } from 'hooks/pubsub/usePubSub'
import { useLocalStorageState } from 'hooks/useStorage'
import React from 'react'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router'
import { isUndefinedOrNull } from 'util/checks'
import { RelatoriosRecentesModal } from 'view/arquivo/RelatoriosRecentesModal'

import {
  ArquivoTemporarioFormato,
  MensagemErroArquivoTemporarioMaisRecente,
  relatoriosRecentesRecord,
} from './model-arquivo'
import UltimoRelatorioStatus from './UltimoRelatorioStatus'

export const RELATORIOS_RECENTES_URL = '/relatorios-recentes'

export interface RelatoriosRecentesProps {
  identificadorModuloArquivo: ArquivoTemporarioIdentificadorEnum
  setShouldRefetch: (boolean) => void
  setStatusRelatorio?: (ArquivoTemporarioStatusEnum) => void
}

export function RelatoriosRecentes(props: Readonly<RelatoriosRecentesProps>) {
  const { identificadorModuloArquivo, setShouldRefetch, setStatusRelatorio } = props
  const { acesso, profissional } = useAcessoLotacaoOrEstagio()
  const match = useRouteMatch()
  const history = useHistory()
  const { topicBasePath, fileName } = relatoriosRecentesRecord[identificadorModuloArquivo]
  const usuarioId = profissional?.usuario?.id
  const { handleImpressao } = useHandleImpressao()

  const [mensagemErroArquivoMaisRecente, setMensagemErroArquivoMaisRecente] = useLocalStorageState<
    MensagemErroArquivoTemporarioMaisRecente
  >(`${acesso.id}/${topicBasePath}/erro-relatorio`)

  const {
    data: dataUltimoArquivo,
    loading: loadingUltimoArquivo,
    refetch: refetchUltimoArquivo,
  } = useUltimoArquivoTemporarioProntoEmProcessamentoQuery({
    variables: {
      input: {
        arquivoTemporarioIdentificadorEnum: identificadorModuloArquivo,
      },
    },
    onCompleted: (data) =>
      setStatusRelatorio && setStatusRelatorio(data?.ultimoArquivoTemporarioProntoEmProcessamento?.status),
  })

  usePubSub<ArquivoTemporarioFormato>({
    topic: `/${topicBasePath}/${usuarioId}`,
    onMessage: (responseBody) => {
      if (!isUndefinedOrNull(responseBody.arquivo)) {
        const arquivoTemporario = new Uint8Array(responseBody.arquivo)
        handleImpressao({
          blob: new Blob([arquivoTemporario]),
          file: `${fileName}.${responseBody.formato.toLocaleLowerCase()}`,
          dateFormat: 'yyyy-MM-dd-HH-mm',
        })
        setShouldRefetch(false)
      }
      setMensagemErroArquivoMaisRecente({ arquivoId: responseBody.arquivoId, mensagemErro: responseBody.mensagem })
      refetchUltimoArquivo()
    },
  })

  const handleRelatorioClick = () => {
    history.push(`${match.url}${RELATORIOS_RECENTES_URL}`)
  }

  return (
    <>
      <HFlow alignItems='center'>
        <UltimoRelatorioStatus data={dataUltimoArquivo} loading={loadingUltimoArquivo} />
        <Button kind='primary' skin='outline' size='small' onClick={handleRelatorioClick}>
          Ver relatórios recentes
        </Button>
      </HFlow>
      <Switch>
        <Route exact path={`${match.url}${RELATORIOS_RECENTES_URL}`}>
          <RelatoriosRecentesModal
            identificadorModuloArquivo={identificadorModuloArquivo}
            fileName={fileName}
            mensagemErroArquivoMaisRecente={mensagemErroArquivoMaisRecente}
            setShouldRefetch={setShouldRefetch}
          />
        </Route>
      </Switch>
    </>
  )
}
